export enum XRFeatureType {
  AnchorTracking,
  ImageTracking,
  PlaneTracking,
  HitTest
}
